export enum Keys {
	KEY_BACKSPACE = 8,
	KEY_DELETE = 46,
	KEY_ENTER = 13,
	KEY_TAB = 9,
}
